import request from "@/utils/request";

const {ElMessage} = require("element-plus");
export default {
    name: "Login",
    data() {
        return {
            identity: "",
            isMobile: window.innerWidth <= 768,
            form: {
                username: "",
                password: "",
                phone_num: "",
                identity: "student",
            },
            rules: {
                username: [
                    {required: true, message: "请输入用户名", trigger: "blur"},
                ],
                phone_num: [
                    {required: true, message: "请输入手机号", trigger: "blur"},
                ],
                password: [{required: true, message: "请输入密码", trigger: "blur"}],
                identity: [{required: true, message: "请选择身份", trigger: "blur"}],
            },
        };
    },
    mounted() {
        console.log(process.env.VUE_APP_BASE_URL);
    },
    methods: {
        login() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.identity = this.form.identity;
                const postData = { password: this.form.password };
                if (this.form.identity === 'student') {
                    postData.phone_num = this.form.phone_num;
                } else {
                    postData.username = this.form.username;
                }
                request.post("/" + this.identity + "/login", postData).then((res) => {
                    if (res.code === "0") {
                        ElMessage({
                            message: "登陆成功",
                            type: "success",
                        });
                        window.sessionStorage.setItem("user", JSON.stringify(res.data));
                        window.sessionStorage.setItem("identity", this.form.identity);
                        this.$router.replace({path: "/home"});
                    } else {
                        ElMessage({
                            message: res.msg,
                            type: "error",
                        });
                    }
                });
            });
        },
    },
};
